module.exports = __webpack_public_path__ + "img/orthotic-comfort.bf79f3fd.png";